import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import styles from './reveal.module.scss';
const Reveal = ({ children, parent }) => {
    const observer = useRef();
    const [isParentAvailable, setIsParentAvailable] = useState(false);
    const [visible, setVisible] = React.useState(false);
    const ref = useRef(null);
    useEffect(() => {
        if (parent.current) {
            setIsParentAvailable(true);
        }
    }, [parent.current]);
    const onRef = useCallback((node) => {
        if (node && parent.current) {
            ref.current = node;
            observer.current = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    setVisible(entry.isIntersecting);
                });
            }, {
                root: parent.current,
                threshold: [0, 0.25, 0.5, 0.75, 1],
            });
            observer.current.observe(node);
        }
    }, []);
    const revealClass = useMemo(() => classNames(styles.reveal, {
        [styles.hide]: !visible,
        [styles.show]: visible,
    }), [visible]);
    // cleanup
    useEffect(() => {
        return () => {
            observer.current?.disconnect();
        };
    }, []);
    return (_jsx("div", { className: styles.wrapper, children: isParentAvailable && (_jsx("div", { className: revealClass, ref: onRef, children: children })) }));
};
Reveal.displayName = 'Reveal';
export { Reveal };
